module.exports = __webpack_public_path__ + "static/media/about-bg.946a8c94.jpg";